export default {
  Global: {
    _id: '5dd87a579f575bd88342039f',
    name: 'Global',
    countries: ['GLOBAL'],
  },
  AE: {
    _id: '5dd87a599f575bd8834203e0',
    name: 'United Arab Emirates',
    countries: ['AE'],
  },
  AG: {
    _id: '5dd87a599f575bd8834203eb',
    name: 'Antigua and Barbuda',
    countries: ['AG'],
  },
  AI: {
    _id: '5dd87a599f575bd8834203f5',
    name: 'Anguilla',
    countries: ['AI'],
  },
  AR: {
    _id: '5dd87a599f575bd8834203ff',
    name: 'Argentina',
    countries: ['AR'],
  },
  AT: {
    _id: '5dd87a5a9f575bd883420409',
    name: 'Austria',
    countries: ['AT'],
  },
  AU: {
    _id: '5dd87a5a9f575bd883420413',
    name: 'Australia',
    countries: ['AU'],
  },
  AW: {
    _id: '5dd87a5a9f575bd88342041e',
    name: 'Aruba',
    countries: ['AW'],
  },
  BB: {
    _id: '5dd87a5a9f575bd883420428',
    name: 'Barbados',
    countries: ['BB'],
  },
  BD: {
    _id: '5dd87a5a9f575bd883420432',
    name: 'Bangladesh',
    countries: ['BD'],
  },
  BE: {
    _id: '5dd87a5a9f575bd88342043c',
    name: 'Belgium',
    countries: ['BE'],
  },
  BG: {
    _id: '5dd87a5a9f575bd883420446',
    name: 'Bulgaria',
    countries: ['BG'],
  },
  BH: {
    _id: '5dd87a5a9f575bd883420451',
    name: 'Bahrain',
    countries: ['BH'],
  },
  BL: {
    _id: '5dd87a5a9f575bd88342045b',
    name: 'Saint Barthelemy',
    countries: ['BL'],
  },
  BN: {
    _id: '5dd87a5a9f575bd883420465',
    name: 'Brunei',
    countries: ['BN'],
  },
  BO: {
    _id: '5dd87a5a9f575bd88342046f',
    name: 'Bolivia',
    countries: ['BO'],
  },
  BQ: {
    _id: '5dd87a5a9f575bd88342047a',
    name: 'Bonaire, Sint Eustatius and Saba',
    countries: ['BQ'],
  },
  BR: {
    _id: '5dd87a5a9f575bd883420484',
    name: 'Brazil',
    countries: ['BR'],
  },
  BS: {
    _id: '5dd87a5b9f575bd88342048e',
    name: 'Bahamas',
    countries: ['BS'],
  },
  BT: {
    _id: '5dd87a5b9f575bd883420498',
    name: 'Bhutan',
    countries: ['BT'],
  },
  BV: {
    _id: '5dd87a5b9f575bd8834204a2',
    name: 'Bouvet Island',
    countries: ['BV'],
  },
  BZ: {
    _id: '5dd87a5b9f575bd8834204ac',
    name: 'Belize',
    countries: ['BZ'],
  },
  CA: {
    _id: '5dd87a5b9f575bd8834204b6',
    name: 'Canada',
    countries: ['CA'],
  },
  CH: {
    _id: '5dd87a5b9f575bd8834204c0',
    name: 'Switzerland',
    countries: ['CH'],
  },
  CL: {
    _id: '5dd87a5b9f575bd8834204ca',
    name: 'Chile',
    countries: ['CL'],
  },
  CN: {
    _id: '5dd87a5b9f575bd8834204d4',
    name: 'China',
    countries: ['CN'],
  },
  CO: {
    _id: '5dd87a5b9f575bd8834204de',
    name: 'Colombia',
    countries: ['CO'],
  },
  CR: {
    _id: '5dd87a5b9f575bd8834204e8',
    name: 'Costa Rica',
    countries: ['CR'],
  },
  CU: {
    _id: '5dd87a5c9f575bd8834204f3',
    name: 'Cuba',
    countries: ['CU'],
  },
  CW: {
    _id: '5dd87a5c9f575bd8834204fd',
    name: 'Curacao',
    countries: ['CW'],
  },
  CY: {
    _id: '5dd87a5d9f575bd88342050c',
    name: 'Cyprus',
    countries: ['CY'],
  },
  CZ: {
    _id: '5dd87a5d9f575bd88342056a',
    name: 'Czech Republic',
    countries: ['CZ'],
  },
  DE: {
    _id: '5dd87a5e9f575bd883420578',
    name: 'Germany',
    countries: ['DE'],
  },
  DK: {
    _id: '5dd87a5f9f575bd883420584',
    name: 'Denmark',
    countries: ['DK'],
  },
  DM: {
    _id: '5dd87a5f9f575bd88342058e',
    name: 'Dominica',
    countries: ['DM'],
  },
  DO: {
    _id: '5dd87a5f9f575bd883420599',
    name: 'Dominican Republic',
    countries: ['DO'],
  },
  DZ: {
    _id: '5dd87a5f9f575bd8834205a3',
    name: 'Algeria',
    countries: ['DZ'],
  },
  EC: {
    _id: '5dd87a5f9f575bd8834205ad',
    name: 'Ecuador',
    countries: ['EC'],
  },
  EE: {
    _id: '5dd87a5f9f575bd8834205b7',
    name: 'Estonia',
    countries: ['EE'],
  },
  EG: {
    _id: '5dd87a5f9f575bd8834205c1',
    name: 'Egypt',
    countries: ['EG'],
  },
  ES: {
    _id: '5dd87a609f575bd8834205cc',
    name: 'Spain',
    countries: ['ES'],
  },
  FI: {
    _id: '5dd87a609f575bd8834205d6',
    name: 'Finland',
    countries: ['FI'],
  },
  FK: {
    _id: '5dd87a609f575bd8834205e2',
    name: 'Falkland Islands(Malvinas)',
    countries: ['FK'],
  },
  FO: {
    _id: '5dd87a609f575bd8834205ed',
    name: 'Faroe Islands',
    countries: ['FO'],
  },
  FR: {
    _id: '5dd87a609f575bd8834205f7',
    name: 'France',
    countries: ['FR'],
  },
  GB: {
    _id: '5dd87a609f575bd883420608',
    name: 'United Kingdom',
    countries: ['GB'],
  },
  GD: {
    _id: '5dd87a609f575bd88342061c',
    name: 'Grenada',
    countries: ['GD'],
  },
  GF: {
    _id: '5dd87a609f575bd883420626',
    name: 'French Guiana',
    countries: ['GF'],
  },
  GH: {
    _id: '5dd87a609f575bd883420630',
    name: 'Ghana',
    countries: ['GH'],
  },
  GL: {
    _id: '5dd87a609f575bd88342063a',
    name: 'Greenland',
    countries: ['GL'],
  },
  GP: {
    _id: '5dd87a609f575bd883420645',
    name: 'Guadeloupe',
    countries: ['GP'],
  },
  GR: {
    _id: '5dd87a609f575bd883420650',
    name: 'Greece',
    countries: ['GR'],
  },
  GS: {
    _id: '5dd87a609f575bd88342065b',
    name: 'South Georgia and the South Sandwich Islands',
    countries: ['GS'],
  },
  GT: {
    _id: '5dd87a609f575bd883420665',
    name: 'Guatemala',
    countries: ['GT'],
  },
  GY: {
    _id: '5dd87a619f575bd88342066f',
    name: 'Guyana',
    countries: ['GY'],
  },
  HN: {
    _id: '5dd87a619f575bd883420679',
    name: 'Honduras',
    countries: ['HN'],
  },
  HK: {
    _id: '5dd87a619f575bd883420683',
    name: 'Hong Kong',
    countries: ['HK'],
  },
  HR: {
    _id: '5dd87a619f575bd88342068d',
    name: 'Croatia',
    countries: ['HR'],
  },
  HT: {
    _id: '5dd87a619f575bd883420697',
    name: 'Haiti',
    countries: ['HT'],
  },
  HU: {
    _id: '5dd87a619f575bd8834206a1',
    name: 'Hungary',
    countries: ['HU'],
  },
  ID: {
    _id: '5dd87a619f575bd8834206ab',
    name: 'Indonesia',
    countries: ['ID'],
  },
  IE: {
    _id: '5dd87a619f575bd8834206b5',
    name: 'Ireland',
    countries: ['IE'],
  },
  IL: {
    _id: '5dd87a619f575bd8834206bf',
    name: 'Israel',
    countries: ['IL'],
  },
  IN: {
    _id: '5dd87a619f575bd8834206c9',
    name: 'India',
    countries: ['IN'],
  },
  IQ: {
    _id: '5dd87a619f575bd8834206d4',
    name: 'Iraq',
    countries: ['IQ'],
  },
  IS: {
    _id: '5dd87a619f575bd8834206df',
    name: 'Iceland',
    countries: ['IS'],
  },
  IT: {
    _id: '5dd87a619f575bd8834206e9',
    name: 'Italy',
    countries: ['IT'],
  },
  JM: {
    _id: '5dd87a619f575bd8834206f3',
    name: 'Jamaica',
    countries: ['JM'],
  },
  JO: {
    _id: '5dd87a629f575bd8834206fd',
    name: 'Jordan',
    countries: ['JO'],
  },
  JP: {
    _id: '5dd87a629f575bd883420708',
    name: 'Japan',
    countries: ['JP'],
  },
  KH: {
    _id: '5dd87a629f575bd883420712',
    name: 'Cambodia',
    countries: ['KH'],
  },
  KE: {
    _id: '5dd87a629f575bd88342071c',
    name: 'Kenya',
    countries: ['KE'],
  },
  KN: {
    _id: '5dd87a629f575bd883420726',
    name: 'Saint Kitts and Nevis',
    countries: ['KN'],
  },
  KP: {
    _id: '621006ec75b510001283fb8e',
    countries: ['KP'],
    name: 'North Korea',
  },
  KR: {
    _id: '5dd87a629f575bd88342073a',
    name: 'Korea, Republic of',
    countries: ['KR'],
  },
  KW: {
    _id: '5dd87a629f575bd883420744',
    name: 'Kuwait',
    countries: ['KW'],
  },
  KY: {
    _id: '5dd87a629f575bd88342074e',
    name: 'Cayman Islands',
    countries: ['KY'],
  },
  LA: {
    _id: '5dd87a629f575bd883420758',
    name: 'Laos',
    countries: ['LA'],
  },
  LC: {
    _id: '5dd87a629f575bd883420763',
    name: 'Saint Lucia',
    countries: ['LC'],
  },
  LK: {
    _id: '5dd87a629f575bd88342076d',
    name: 'Sri Lanka',
    countries: ['LK'],
  },
  LT: {
    _id: '5dd87a629f575bd883420777',
    name: 'Lithuania',
    countries: ['LT'],
  },
  LU: {
    _id: '5dd87a639f575bd883420781',
    name: 'Luxembourg',
    countries: ['LU'],
  },
  LV: {
    _id: '5dd87a639f575bd88342078b',
    name: 'Latvia',
    countries: ['LV'],
  },
  MA: {
    _id: '5dd87a639f575bd883420795',
    name: 'Morocco',
    countries: ['MA'],
  },
  MF: {
    _id: '5dd87a639f575bd8834207a0',
    name: 'Saint Martin (French part)',
    countries: ['MF'],
  },
  MM: {
    _id: '5dd87a639f575bd8834207aa',
    name: 'Myanmar',
    countries: ['MM'],
  },
  MN: {
    _id: '5dd87a639f575bd8834207b4',
    name: 'Mongolia',
    countries: ['MN'],
  },
  MQ: {
    _id: '5dd87a639f575bd8834207bf',
    name: 'Martinique',
    countries: ['MQ'],
  },
  MS: {
    _id: '5dd87a639f575bd8834207c9',
    name: 'Montserrat',
    countries: ['MS'],
  },
  MT: {
    _id: '5dd87a639f575bd8834207d3',
    name: 'Malta',
    countries: ['MT'],
  },
  MV: {
    _id: '5dd87a639f575bd8834207de',
    name: 'Maldives',
    countries: ['MV'],
  },
  MX: {
    _id: '5dd87a639f575bd8834207e8',
    name: 'Mexico',
    countries: ['MX'],
  },
  MY: {
    _id: '5dd87a639f575bd8834207f3',
    name: 'Malaysia',
    countries: ['MY'],
  },
  NG: {
    _id: '5dd87a639f575bd8834207fd',
    name: 'Nigeria',
    countries: ['NG'],
  },
  NI: {
    _id: '5dd87a639f575bd883420807',
    name: 'Nicaragua',
    countries: ['NI'],
  },
  NL: {
    _id: '5dd87a649f575bd883420811',
    name: 'Netherlands',
    countries: ['NL'],
  },
  NO: {
    _id: '5dd87a649f575bd88342081c',
    name: 'Norway',
    countries: ['NO'],
  },
  NP: {
    _id: '5dd87a649f575bd883420826',
    name: 'Nepal',
    countries: ['NP'],
  },
  NZ: {
    _id: '5dd87a649f575bd883420830',
    name: 'New Zealand',
    countries: ['NZ'],
  },
  OM: {
    _id: '5dd87a649f575bd88342083a',
    name: 'Oman',
    countries: ['OM'],
  },
  PA: {
    _id: '5dd87a649f575bd883420844',
    name: 'Panama',
    countries: ['PA'],
  },
  PE: {
    _id: '5dd87a649f575bd88342084e',
    name: 'Peru',
    countries: ['PE'],
  },
  PH: {
    _id: '5dd87a649f575bd883420859',
    name: 'Philippines',
    countries: ['PH'],
  },
  PK: {
    _id: '5dd87a649f575bd883420863',
    name: 'Pakistan',
    countries: ['PK'],
  },
  PL: {
    _id: '5dd87a649f575bd88342086d',
    name: 'Poland',
    countries: ['PL'],
  },
  PR: {
    _id: '5dd87a649f575bd883420878',
    name: 'Puerto Rico',
    countries: ['PR'],
  },
  PT: {
    _id: '5dd87a649f575bd883420882',
    name: 'Portugal',
    countries: ['PT'],
  },
  PY: {
    _id: '5dd87a659f575bd883420892',
    name: 'Paraguay',
    countries: ['PY'],
  },
  QA: {
    _id: '5dd87a659f575bd88342089c',
    name: 'Qatar',
    countries: ['QA'],
  },
  RO: {
    _id: '5dd87a659f575bd8834208a6',
    name: 'Romania',
    countries: ['RO'],
  },
  RU: {
    _id: '5dd87a659f575bd8834208b0',
    name: 'Russian Federation',
    countries: ['RU'],
  },
  SA: {
    _id: '5dd87a659f575bd8834208ba',
    name: 'Saudi Arabia',
    countries: ['SA'],
  },
  SE: {
    _id: '5dd87a659f575bd8834208c4',
    name: 'Sweden',
    countries: ['SE'],
  },
  SI: {
    _id: '5dd87a659f575bd8834208ce',
    name: 'Slovenia',
    countries: ['SI'],
  },
  SG: {
    _id: '5dd87a659f575bd8834208d8',
    name: 'Singapore',
    countries: ['SG'],
  },
  SK: {
    _id: '5dd87a659f575bd8834208e2',
    name: 'Slovakia',
    countries: ['SK'],
  },
  SR: {
    _id: '5dd87a659f575bd8834208ec',
    name: 'Suriname',
    countries: ['SR'],
  },
  SV: {
    _id: '5dd87a659f575bd8834208fa',
    name: 'El Salvador',
    countries: ['SV'],
  },
  SX: {
    _id: '5dd87a659f575bd88342090a',
    name: 'Saint Maarten (Dutch part)',
    countries: ['SX'],
  },
  TC: {
    _id: '5dd87a659f575bd883420914',
    name: 'Turks and Caicos Islands',
    countries: ['TC'],
  },
  TH: {
    _id: '5dd87a659f575bd88342091e',
    name: 'Thailand',
    countries: ['TH'],
  },
  TR: {
    _id: '5dd87a669f575bd883420928',
    name: 'Turkey',
    countries: ['TR'],
  },
  TT: {
    _id: '5dd87a669f575bd883420933',
    name: 'Trinidad and Tobago',
    countries: ['TT'],
  },
  TW: {
    _id: '5dd87a669f575bd88342093d',
    name: 'Taiwan',
    countries: ['TW'],
  },
  US: {
    _id: '5dd87a669f575bd883420947',
    name: 'United States',
    countries: ['US'],
  },
  UY: {
    _id: '5dd87a669f575bd883420951',
    name: 'Uruguay',
    countries: ['UY'],
  },
  VC: {
    _id: '5dd87a669f575bd88342095b',
    name: 'Saint Vincent and the Grenadines',
    countries: ['VC'],
  },
  VE: {
    _id: '5dd87a669f575bd883420965',
    name: 'Venezuela',
    countries: ['VE'],
  },
  VG: {
    _id: '5dd87a669f575bd88342096f',
    name: 'Virgin Islands (British)',
    countries: ['VG'],
  },
  VI: {
    _id: '5dd87a669f575bd883420979',
    name: 'Virgin Islands (U.S.)',
    countries: ['VI'],
  },
  VN: {
    _id: '5dd87a669f575bd883420983',
    name: 'Vietnam',
    countries: ['VN'],
  },
  ZA: {
    _id: '5dd87a669f575bd88342098e',
    name: 'South Africa',
    countries: ['ZA'],
  },
  IR: {
    _id: '62bdfae697de3f00197cbe80',
    countries: ['IR'],
    name: 'Iran',
  },
  SY: {
    _id: '62bdfb355f0b9900197edf50',
    countries: ['SY'],
    name: 'Syria',
  },
  AL: {
    _id: '636bf99ff0f8fc0019e7c859',
    countries: ['AL'],
    name: 'Albania',
  },
  AD: {
    _id: '636bf9d7d2b4ef001964890b',
    countries: ['AD'],
    name: 'Andorra',
  },
  BY: {
    _id: '636bf9eef0f8fc0019e7c85a',
    countries: ['BY'],
    name: 'Belarus',
  },
  BA: {
    _id: '636bf9faf0f8fc0019e7c85b',
    countries: ['BA'],
    name: 'Bosnia and Herzegovina',
  },
  LI: {
    _id: '636bfa02d2b4ef001964890f',
    countries: ['LI'],
    name: 'Liechtenstein',
  },
  MD: {
    _id: '636bfa09d2b4ef0019648910',
    countries: ['MD'],
    name: 'Moldova',
  },
  MC: {
    _id: '636bfa11d2b4ef0019648911',
    countries: ['MC'],
    name: 'Monaco',
  },
  ME: {
    _id: '636bfa17f0f8fc0019e7c85c',
    countries: ['ME'],
    name: 'Montenegro',
  },
  MK: {
    _id: '636bfa22d2b4ef0019648912',
    countries: ['MK'],
    name: 'North Macedonia',
  },
  SM: {
    _id: '636bfa2ad2b4ef0019648913',
    countries: ['SM'],
    name: 'San Marino',
  },
  RS: {
    _id: '636bfa32f0f8fc0019e7c85d',
    countries: ['RS'],
    name: 'Serbia',
  },
  UA: {
    _id: '636bfa70f0f8fc0019e7c85e',
    countries: ['UA'],
    name: 'Ukraine',
  },
  VA: {
    _id: '636bfa82d2b4ef0019648914',
    countries: ['VA'],
    name: 'Vatican City',
  },
}
